export const NATURE_OF_EMPLOYMENT_OPTIONS = [
  'Permanent',
  'Contract',
  'Temporary'
];
